import { toast } from '@/Components/ui/use-toast';
import axios from 'axios';
import { useState } from 'react';

export const useSubscribe = () => {
    const [isLoading, setIsLoading] = useState(false);

    const subscribe = async (email: string) => {
        setIsLoading(true);
        try {
            const response = await axios.post('/newsletter/subscribe', {
                email,
            });
            toast({
                description: 'Successfully subscribed to the newsletter!',
            });
            return response.data;
        } catch (error: unknown) {
            if (axios.isAxiosError(error) && error.response?.status === 422) {
                toast({
                    description: 'This email is already subscribed.',
                    variant: 'destructive',
                });
            } else {
                toast({
                    description: 'An error occurred. Please try again later.',
                    variant: 'destructive',
                });
            }
            throw error;
        } finally {
            setIsLoading(false);
        }
    };

    return { subscribe, isLoading };
};
